const initializedGroups = new WeakSet();

const isMfaInput = event => {
    return event.target.classList.contains('mfa') && event.target.tagName === 'INPUT';
}

const inputsAround = input => {
    return input.closest('.mfa-input-group').querySelectorAll('input.mfa');
}

const distribute = (input, content) => {
    const digits = content.replace(/\s/g, '');

    if (!/^\d+$/.test(digits)) {
        return;
    }

    const inputs  = inputsAround(input);
    const numbers = digits.split('').slice(0, inputs.length);

    inputs.forEach((node, index) => {
        node.value = numbers[index] ?? '';
    });

    inputs[Math.min(numbers.length, inputs.length - 1)].focus();
}

export const distributePastedMfaCode = event => {
    if (!isMfaInput(event)) {
        return;
    }

    event.preventDefault();

    const content = event.clipboardData.getData('text');

    if (!content) {
        return;
    }

    distribute(event.target, content);
}

export const distributeFilledMfaCode = event => {
    if (!isMfaInput(event) || event.target.value.length < 2) {
        return;
    }

    distribute(event.target, event.target.value);
}

export const advanceMfaInput = event => {
    if (!isMfaInput(event)) {
        return;
    }

    const input = event.target;

    if (!/^\d+$/.test(input.value)) {
        input.value = '';
    }

    if (event.key === 'Delete') {
        input.value = '';
    }

    const isNumericKey = (event.key >= '0' && event.key <= '9' && event.shiftKey === false);

    if (isNumericKey && input.value) {
        input.value = event.key;

        if (input.nextElementSibling) {
            input.nextElementSibling.focus();
            input.nextElementSibling.select();
        }
    }

    if (event.key === 'ArrowRight' && input.nextElementSibling) {
        input.nextElementSibling.focus();
        input.nextElementSibling.select();
    }

    if (event.key === 'ArrowLeft' && input.previousElementSibling) {
        input.previousElementSibling.focus();
        input.previousElementSibling.select();
    }
}

export const clearMfaInput = event => {
    if (!isMfaInput(event)) {
        return;
    }

    const input = event.target;

    if (event.key === 'Backspace') {
        if (input.value) {
            input.value = '';

            return;
        }

        if (input.previousElementSibling) {
            input.previousElementSibling.focus();
            input.previousElementSibling.value = '';
        }

        return;
    }

    const isNumericKey = (event.key >= '0' && event.key <= '9' && event.shiftKey === false);

    if (input.value && isNumericKey) {
        input.value = '';
    }
}

export const initializeMfaInputs = root => {
    root.querySelectorAll('.mfa-input-group').forEach(group => {
        if (initializedGroups.has(group)) {
            return;
        }

        initializedGroups.add(group);

        group.querySelector('input.mfa')?.focus();
    });
}
